import { render, staticRenderFns } from "./ClassroomDetailTabInputGroupName.vue?vue&type=template&id=2b58d0b1&scoped=true"
import script from "./ClassroomDetailTabInputGroupName.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailTabInputGroupName.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailTabInputGroupName.vue?vue&type=style&index=0&id=2b58d0b1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b58d0b1",
  null
  
)

export default component.exports